import { HttpEvent } from '@angular/common/module.d-CnjH8Dlt';
import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

const PREFIX = 'PREZERO_';

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    public clear() {
        Preferences.keys()
            .then(({ keys }) => {
                const toRemove = keys.filter((k) => k.includes(PREFIX))
                toRemove.map((key) => {
                    Preferences.remove({ key })
                        .then(() => console.log('removed: ' + key))
                })
            })
    }

    public store(key: string, value: any) {
        return Preferences.set({
            key: PREFIX + key,
            value: JSON.stringify(value)
        })
    }

    public get(key: string): any | null {
        return Preferences.get({ key: PREFIX + key })
            .then((data) => {
                if (data?.value) {
                    return JSON.parse(data.value) as HttpEvent<any>;
                }

                return null;
            })
    }

}
